module.exports = __webpack_public_path__ + "static/img/yuanhui.1de352f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yuanhui.png
// module id = iIWZ
// module chunks = 1